<template>
  <div>
    <div class="container mains">
      <div v-html="zhifusrc">{{zhifusrc}}</div>
    </div>
  </div>
</template>
<script>
import { zhifubao, getorder, alipay } from "../api/order/order";
const formJson = {
  consignee: "",
  mobile: "",
  sheng: "",
  shi: "",
  qu: "",
  address: "",
  user_id: "",
  order_id: ""
};
export default {
  name: "chongzhizhifu",
  data() {
    return {
      htmls: "",
      zhifusrc: "",
      input: "",
      active_id: "",
      active_amount: "",
      active_give_amount: "",
      user_id: ""
    };
  },
  methods: {
    getorderinfo() {
      this.htmls = this.$route.query.htmls;
      const div = document.createElement("div");
      div.innerHTML = this.htmls;
      document.body.appendChild(div);
      document.forms[0].submit();
    }
  },
  created() {
    this.getorderinfo();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/chongzhizhifu.vue